import { render, staticRenderFns } from "./articleDelete.vue?vue&type=template&id=9afa1b3a&scoped=true&"
import script from "./articleDelete.vue?vue&type=script&lang=js&"
export * from "./articleDelete.vue?vue&type=script&lang=js&"
import style0 from "./articleDelete.vue?vue&type=style&index=0&id=9afa1b3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9afa1b3a",
  null
  
)

export default component.exports